<template>
  <div ref="tempDivAudio">
    <!-- 消息提示音 -->
    <audio hidden ref="audio" @play="handleOnplay" @ended="handlePlayEnd">
      <source :src="require(`@assets/audio/notice${noticeItem}.mp3`)" type="audio/ogg" />
    </audio>
    <!-- 新线索提音 -->
    <audio hidden ref="audioLead" @play="handleOnplayLead" @ended="handlePlayEndLead">
      <source :src="require(`@assets/audio/leads1.mp3`)" type="audio/ogg" />
    </audio>
    <!-- 语音消息 -->
    <audio hidden ref="audioMsg" @ended="handlePlayAudioEnd">
      <source :src="audioMsgUrl" type="audio/ogg" />
    </audio>
  </div>
</template>

<script setup>
import { inject, nextTick, onMounted, ref, computed, onUnmounted, watch } from "vue";
import { useStore } from "vuex";
const bus = inject("$eventBus");
const wsCmd = inject("wsCmd");
const eventbusCms = inject("eventbusCms");

const store = useStore();
const audio = ref();
const playing = ref(false);
const tempDivAudio = ref();

//线索提示音
const audioLead = ref(undefined)
const audioLeadPlaying = ref(false);

//语音消息
const audioMsg = ref(undefined)
const audioMsgUrl = ref('https://s-m.lm12301.com/online/servie_msg.mp3')

const userInfo = computed(() => {
  return store.state.user.user;
});
const noticeItem = computed(() => {
  return store.state.profile.noticeItem
})

//提醒声音是否开启
const noticeStatus = computed(() => {
  return store.state.profile.noticeStatus;
});

//进入会话提示音
const enter_direct_notice_flg = computed(() => {
  return userInfo.value.enter_direct_notice_flg
})
//线索提示音
const new_customer_notice_flg = computed(() => {
  return userInfo.value.new_customer_notice_flg
})

//播放语音消息
const playAudioMsg = async({id,audioUrl})=>{
  if(!audioUrl){
    return
  }
  store.commit("profile/SET_AUDIO_MSG_ID",id);
  audioMsgUrl.value = audioUrl
  audioMsg.value.load()
  audioMsg.value.play()
}

const plays = () => {
  if (noticeStatus.value !== '1') {
    return;
  }
  if (audio.value && !playing.value) {
    try {
      audio.value.play();
    } catch (e) {
      console.error(e);
    }
  }
};


const playsLeads = () => {
  if (new_customer_notice_flg.value != 1) {
    return;
  }
  if (audioLead.value && !audioLeadPlaying.value) {
    try {
      audioLead.value.play();
    } catch (e) {
      console.error(e);
    }
  }
};

//线索音
const handleOnplayLead = () => {
  audioLeadPlaying.value = true;
};

const handlePlayEndLead = () => {
  audioLeadPlaying.value = false;
};


//消息提示音
const handleOnplay = () => {
  playing.value = true;
};

const handlePlayEnd = () => {
  playing.value = false;
};

//语音消息
const handlePlayAudioEnd = async()=>{
   store.commit("profile/SET_AUDIO_MSG_ID",0);
}

const playNotice = (data) => {
  let canPlay = true
  let { t, sub_t } = data

  if (t == wsCmd.cmd_33) {
    //新线索提示
    playsLeads()
  } else {
    //消息提示
    //消息来源
    if (t == 4 && sub_t == "4_1") {
      //进入会话消息
      if (enter_direct_notice_flg.value != 1) {
        canPlay = false
      }
    }
    if (canPlay) {
      plays();
    }
  }



};

watch(
  () => store.state.profile.noticeItem,
  (_) => {
    audio.value.load()
  }
)

onMounted(() => {
  bus.on(`${wsCmd.cmd_100_resp}`, playNotice)   // listen
  bus.on(`${eventbusCms.play_audio_msg}`, playAudioMsg)   // listen
});

onUnmounted(() => {
  bus.off(`${wsCmd.cmd_100_resp}`)   // listen
  bus.off(`${eventbusCms.play_audio_msg}`)   // listen
})

</script>